export default "__VITE_ASSET__Ddxeup5g__"